import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const LOGOUT_IN_PROGRESS_STATUS = "LOGOUT_IN_PROGRESS";

const shouldSkipRequestDuringLogout = (state) =>
  Boolean(state?.loaderReducer?.logoutLoading);

export const createBaseQueryWithLogoutGuard = (options = {}) => {
  const rawBaseQuery = fetchBaseQuery(options);

  return async (args, api, extraOptions) => {
    if (shouldSkipRequestDuringLogout(api?.getState?.())) {
      return {
        error: {
          status: LOGOUT_IN_PROGRESS_STATUS,
          data: {
            message: "Request skipped during logout",
            error: LOGOUT_IN_PROGRESS_STATUS,
          },
        },
      };
    }

    return rawBaseQuery(args, api, extraOptions);
  };
};
